<!--
  Halloween, in the profile menu: the hat every face wears on the member's
  screen. Hidden when Halloween is off.
-->
<template>
  <div v-if="enabled" class="px-4 py-2" test_id="halloween-hat-picker">
    <div class="text-sm text-neutral-700">Halloween hats</div>
    <div class="mt-1.5 flex flex-wrap gap-1">
      <button
        v-for="option in HALLOWEEN_HATS"
        :key="option.value"
        type="button"
        class="rounded-lg px-2.5 py-1 text-[13px] transition-colors"
        :class="
          hat === option.value
            ? 'bg-secondary-50 text-secondary-700 font-medium'
            : 'text-neutral-600 hover:text-neutral-900'
        "
        :aria-pressed="hat === option.value"
        @click="setHat(option.value)"
      >
        {{ option.label }}
      </button>
    </div>
    <p class="mt-1.5 text-xs text-neutral-400">
      Every face wears it on your screen until 1 November.
    </p>
  </div>
</template>

<script setup lang="ts">
import { HALLOWEEN_HATS, useHalloween } from '@/shared/composables/useHalloween'

const { enabled, hat, setHat } = useHalloween()
</script>
